import { MobileCommMessageText } from "../MobileCommMessageText";
import { Button, DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommMessageQuickInfo extends Layout {
    buttonViewMessage: Button;
    layoutMobileCommMessageText: MobileCommMessageText;
    panelQuickInfo: Panel;
    sourceMobileCommMessage: DataSource;
}
